<footer class="footer-area" role="contentinfo">
        <div class="d-flex justify-content-center">
                <ul class="list">
                        <li>
                                <a (click)="redirectHomePage()" href="javascript:void(0)">HOME</a>
                                <span aria-hidden="true"> | </span>
                        </li>
                        <li>
                                <a [href]="accessibilityLink" target="_blank" rel="noopener">ACCESSIBILITY</a>
                        </li>
                </ul>
        </div>
</footer>